/* src/app/shared/components/no-internet-toastr/no-internet-toastr.component.scss */
.no-internet-toastr-wrap {
  display: flex;
  position: fixed;
  flex-direction: column-reverse;
  bottom: 0px;
  left: 0;
  width: 100%;
  min-height: 32px;
  z-index: 100;
  color: var(--tds-white);
}
.no-internet-toastr-wrap > .no-network-non-closable {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background-color: var(--tds-blue);
  padding: 10px;
}
.no-internet-toastr-wrap > .no-network-non-closable > i {
  margin-right: 1rem;
}
.no-internet-toastr-wrap > .no-network-closable {
  flex: 1;
  display: flex;
  background-color: var(--tds-blue);
}
.no-internet-toastr-wrap > .no-network-closable > div {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  padding: 0.5rem;
}
.no-internet-toastr-wrap > .no-network-closable > div > strong {
  color: var(--interaction-warning);
  padding: 0 1rem;
}
.no-internet-toastr-wrap > .no-network-closable > div > span {
  text-align: center;
}
.no-internet-toastr-wrap > .no-network-closable > span {
  min-width: 3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.5rem;
}
.no-internet-toastr-wrap > .no-network-closable > span > i {
  font-size: 2rem;
}
.no-internet-toastr-wrap.closed {
  width: unset;
}
@media only screen and (min-width: 576px) {
  .no-internet-toastr-wrap {
    flex-direction: row;
  }
  .no-internet-toastr-wrap > .no-network-non-closable {
    flex-direction: column;
  }
  .no-internet-toastr-wrap.closed > .no-network-non-closable {
    flex-direction: row;
  }
}
@media only screen and (min-width: 768px) {
  .no-internet-toastr-wrap > .no-network-non-closable {
    flex-direction: row;
  }
}
/*# sourceMappingURL=no-internet-toastr.component.css.map */
